import { render, staticRenderFns } from "./homeBrands.vue?vue&type=template&id=0e3baa29"
import script from "./homeBrands.vue?vue&type=script&lang=ts"
export * from "./homeBrands.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports